export const selectAudios = (state) => state.audio.audios;
export const selectAudiosLoading = (state) => state.audio.loading;
export const selectAudioSaving = (state) => state.audio.saving;
export const selectAudioBulkSaving = (state) => state.audio.bulkSaving;
export const selectAudioBulkCompletedAt = (state) => state.audio.bulkCompletedAt;
export const selectAudioDetailLoading = (state) => state.audio.detailLoading;
export const selectCurrentPage = (state) => state.audio.currentPage;
export const selectTotalPages = (state) => state.audio.totalPages;
export const selectTotalAudios = (state) => state.audio.totalAudios;
export const selectAudioError = (state) => state.audio.error;
export const selectAudioQuery = (state) => state.audio.query;
export const selectCurrentAudio = (state) => state.audio.currentAudio;
export const selectAudioSuccess = (state) => state.audio.success;
